export const getCurrentDate = () => {
  const currentDate = new Date();
  const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
  const formattedDate = currentDate.toLocaleDateString('en-GB', options).replace(/\//g, '-');
  return formattedDate;
};
